import { FormControlLabel, Switch as MaterialSwitch } from "@mui/material";
import React from "react";
import { getSwitchSx } from "../../util/style";

type SwitchProps = {
    className?: string;
    name: string;
    handleValueChange?: (value: any, field?: string) => void,
    label?: React.ReactNode;
    defaultValue?: boolean;
    disabled?: boolean;
}

export default function Switch({
                                          className,
                                          name,
                                          handleValueChange = () => {},
                                          label,
                                          defaultValue,
                                          disabled
                                      }: SwitchProps) {
    const onChange = (value: boolean) => {
        handleValueChange(value, name);
    }

    return (
        <FormControlLabel
            className={className}
            name={name}
            disabled={disabled}
            onChange={(_, value) => onChange(value)}
            control={
                <MaterialSwitch
                    checked={defaultValue}
                    sx={getSwitchSx(defaultValue ?? false)}
                />
            }
            label={label}
            labelPlacement="end"
            sx={{
                width: 'fit-content',
                justifyContent: 'start',
                '& .MuiFormControlLabel-label': {
                    color: 'text.secondary',
                    opacity: 1,
                },
                '&.Mui-disabled .MuiFormControlLabel-label': {
                    color: 'black',
                },
            }}
        />
    );
}
